import PropTypes from 'prop-types';
import useLiterals from 'utils/hooks/useLiterals';
import { ReactComponent as ShieldCheckIcon } from 'assets/icons/checkout/shield-check.svg';
import { ReactComponent as HeadsetIcon } from 'assets/icons/checkout/headset.svg';

const TrustBadges = ({ className = '' }) => {
  const { badges } = useLiterals('paymentCheckout');

  const items = [
    {
      id: 'secure', Icon: ShieldCheckIcon, title: badges.secureTitle, text: badges.secureText,
    },
    {
      id: 'support', Icon: HeadsetIcon, title: badges.supportTitle, text: badges.supportText,
    },
  ];

  return (
    <ul className={`m-0 list-none space-y-4 p-0 ${className}`}>
      {items.map(({
        id, Icon, title, text,
      }) => (
        <li key={id} className='flex items-center gap-4'>
          <span className='flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-gold-200 bg-white text-gold-500'>
            <Icon aria-hidden='true' className='h-6 w-6' />
          </span>
          <span className='min-w-0'>
            <span className='block text-sm font-semibold text-neutral-800'>{title}</span>
            <span className='block text-[13px] text-neutral-500'>{text}</span>
          </span>
        </li>
      ))}
    </ul>
  );
};

TrustBadges.propTypes = {
  className: PropTypes.string,
};

export default TrustBadges;
